import React, { PropsWithChildren } from 'react';
import { Tag, TagType, TagVariant } from '@cmhc-schl/hearth-ui';

interface StatusPillProps {
  status: string;
  label: string;
}
const getStatusName = (status: string) => {
  switch (status) {
    case '01':
      return 'received';
    case '02':
      return 'validationInProgress';
    case '03':
      return 'validationComplete';
    case '04':
      return 'readyForCreditBureau';
    case '05':
      return 'fileReadyForCreditBureau';
    case '06':
      return 'sentToCreditBureau';
    case '07':
      return 'receivedFromCreditBureau';
    case '08':
      return 'sentToMasterPoolInventory';
    case '09':
      return 'deleted';
    case '10':
      return 'manual';
    case '11':
      return 'readyToCancel';
    case '12':
      return 'cancellationCompleted';
    case '13':
      return 'reviewRequired';
    default:
      return 'received';
  }
};

const getStatusIndicatorColor = (status: string) => {
  switch (status) {
    case 'received':
      return 'Violet';

    case 'sentToMasterPoolInventory':
    case 'cancellationCompleted':
      return 'Green';

    case 'deleted':
      return 'DarkGrey';

    case 'manual':
      return 'Red';

    case 'validationComplete':
      return 'Teal';

    case 'receivedFromCreditBureau':

    case 'validationInProgress':
    case 'readyToCancel':
      return 'Yellow';

    case 'sentToCreditBureau':
    case 'fileReadyForCreditBureau':
    case 'readyForCreditBureau':
      return 'Blue';

    default:
      return 'Yellow';
  }
};

const StatusPill = ({ status, label }: PropsWithChildren<StatusPillProps>) => {
  return (
    <Tag
      label={label}
      tagType={TagType.TAG}
      tagVariant={TagVariant.ICON_READONLY}
      statusIndicator={getStatusIndicatorColor(getStatusName(status))}
      filled
    />
  );
};

export default StatusPill;
